
import axios from "@/utils/request.js";
import qs from "qs"
// 获取活动征集内容
const getLotDetail = (params) => axios({
    url: "/api/web-operate/lottery/manager/lot/detail",
    method: 'get',
    params
})
//获取获奖名单
const getLotWinnerPage = (params) => axios({
    url: "/api/web-operate/lottery/manager/winner/page/notoken",
    method: 'get',
    params
})
//查询我的中奖记录
const getLotWinnerMy = (params) => axios({
    url: "/api/web-operate/lottery/manager/winner/my",
    method: 'get',
    params
})

//获取用户已抽奖次数
const getLotUserCount = (params) => axios({
    url: "/api/web-operate/lottery/manager/lot/user/count",
    method: 'get',
    params
})
//获取奖品分布(8个)
const getLotprizeList = (params) => axios({
    url: "/api/web-operate/lottery/manager/lot/list",
    method: 'get',
    params
})
//抽奖
const getLotluckDraw = (data) => axios({
    url: "/api/web-operate/lottery/manager/lot",
    method: 'post',
    data: qs.stringify(data)
})
//记录浏览量
const getLotPv = (data) => axios({
    url: "/api/web-operate/lottery/manager/lot/pv",
    method: 'post',
    data: qs.stringify(data)
})

export {
    getLotDetail,
    getLotWinnerPage,
    getLotWinnerMy,
    getLotUserCount,
    getLotprizeList,
    getLotluckDraw,
    getLotPv
}